import { connect } from 'react-redux'
import {
  getServices,
  setInputDataService,
  setIsEditCategory,
  setCurrentData,
  setSelectedIdCategory,
  resetInputDataService,
  setFileLogoCategory,
  setErrorLogoInputText,
  resetImageLogo,
  setOpenModalPreviewLogo,
} from 'reduxpath/ducks/Service/List'

import {
  setModalOpen,
  setService,
} from 'reduxpath/ducks/Service/Add'

import {
  updateService,
} from 'reduxpath/ducks/Service/Edit'

import {
  setDeleteModalOpen,
  setSelectedServiceId,
} from 'reduxpath/ducks/Service/Remove'

import {
  getServiceSelections,
} from 'reduxpath/ducks/Format/List'

import { maxPlaceholderDescChar } from 'utils/CustomValidation'
import GeneralUploadFile from 'utils/GeneralUploadFile'

import ServiceCategory from './units'

const mapStateToProps = state => ({
  serviceList: state.ServiceList.data,
  isModalOpen: state.ServiceAdd.isModalOpen,
  productTypes: state.ProductTypeList.data,
  inputAddDataService: state.ServiceList.inputDataService,
  isEditCategory: state.ServiceList.isEditCategory,
  selectedIdCategory: state.ServiceList.selectedIdCategory,
  user: state.Auth.me.user,
  categoryFileLogo: state.ServiceList.categoryFileLogo,
  errorLogoInputText: state.ServiceList.errorLogoInputText,
  isDeleteCategoryModalOpen: state.ServiceRemove.isDeleteCategoryModalOpen,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(key) {
    const limit = 10
    const qs = {
      sort: 'createdAt ASC',
      limit,
      skip: key.selected * limit,
    }
    dispatch(getServices(qs))
  },

  openModalAdd(data) {
    return () => {
      dispatch(setIsEditCategory(false))
      dispatch(setModalOpen(data))
      dispatch(resetInputDataService())
    }
  },

  setInputDataAdd(field) {
    // eslint-disable-next-line consistent-return
    return (e) => {
      let inputValue = e.target.value
      if (field === 'isUsable' || field === 'isSearchable') {
        inputValue = e.target.checked
      }

      if (field === 'logo') {
        inputValue = e.target.result
      }
      const data = {
        field,
        value: inputValue,
      }

      if (field === 'logo') {
        return dispatch(setInputDataService(data))
      }

      if (e.target.value.length <= maxPlaceholderDescChar) {
        dispatch(setInputDataService(data))
      }
    }
  },

  setDescPlaceholder(e) {
    const data = {
      field: 'serviceDesc',
      value: e.target.value,
    }
    dispatch(setInputDataService(data))
  },

  addNewService(data, categoryFileLogo) {
    return async () => {
      const uploadPayload = {
        pathName: 'logo/category',
        file: categoryFileLogo,
      }
      const uploadResponse = await GeneralUploadFile(dispatch, uploadPayload)
      const uploadFile = uploadResponse[0]
      const fileUrlRaw = uploadFile.fileUrlRaw

      if (!fileUrlRaw) {
        return {}
      }

      const dataCategory = { ...data }
      dataCategory.logo = fileUrlRaw
      return dispatch(setService(dataCategory, () => {
        const qs = {
          sort: 'name ASC',
          limit: 10,
          skip: 0,
        }
        dispatch(setModalOpen(false))
        dispatch(resetInputDataService())
        dispatch(getServices(qs))
        dispatch(getServiceSelections())
      }))
    }
  },

  setCurrentDataForEdit(service) {
    return () => {
      const data = {
        productType: service.productType.id,
        name: service.name,
        serviceTitle: service.serviceTitle,
        serviceDesc: service.serviceDesc,
        logo: service.logo,
        isUsable: service.isUsable,
        isSearchable: service.isSearchable,
      }
      dispatch(setSelectedIdCategory(service.id))
      dispatch(setIsEditCategory(true))
      dispatch(setCurrentData(data))
      dispatch(setModalOpen(true))
    }
  },

  updateDataService(data, id, categoryFileLogo) {
    if (!categoryFileLogo.type) {
      return () => {
        const dataInput = data
        if (!dataInput.logo) {
          delete dataInput.logo
        }

        dispatch(updateService(dataInput, id, () => {
          const qs = {
            sort: 'createdAt ASC',
            limit: 10,
            skip: 0,
          }
          dispatch(setModalOpen(false))
          dispatch(getServices(qs))
          dispatch(resetInputDataService())
        }))
      }
    }

    return async () => {
      const dataInput = { ...data }
      if (!dataInput.logo) {
        delete dataInput.logo
      }

      const uploadPayload = {
        pathName: 'logo/category',
        file: categoryFileLogo,
      }
      const uploadResponse = await GeneralUploadFile(dispatch, uploadPayload)
      const uploadFile = uploadResponse[0]
      const fileUrlRaw = uploadFile.fileUrlRaw

      if (!fileUrlRaw) {
        return {}
      }

      dataInput.logo = fileUrlRaw
      return dispatch(updateService(dataInput, id, () => {
        const qs = {
          sort: 'name ASC',
          limit: 10,
          skip: 0,
        }
        dispatch(setModalOpen(false))
        dispatch(getServices(qs))
        dispatch(resetInputDataService())
      }))
    }
  },

  setFileLogoCategory(data) {
    dispatch(setFileLogoCategory(data))
  },

  setErrorLogoInputText(data) {
    dispatch(setErrorLogoInputText(data))
  },

  resetImageLogo() {
    dispatch(resetImageLogo())
  },

  setOpenModalPreviewLogo(data) {
    return () => {
      dispatch(setOpenModalPreviewLogo(data))
    }
  },

  setDeleteCategoryModalOpen(data, id) {
    return () => {
      dispatch(setDeleteModalOpen(data))
      dispatch(setSelectedServiceId(id))
    }
  },
})

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  addNewService: dispatchProps.addNewService(
    stateProps.inputAddDataService,
    stateProps.categoryFileLogo,
  ),
  updateDataService: dispatchProps.updateDataService(
    stateProps.inputAddDataService,
    stateProps.selectedIdCategory,
    stateProps.categoryFileLogo,
  ),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ServiceCategory)
